export default __webpack_public_path__ + "static/media/intermittent-faults.4ccb92de.svg";